import { useState } from 'react';
import { Calendar, Clock, MapPin, CalendarDays } from 'lucide-react';

function Events() {
  const [activeTab, setActiveTab] = useState('All');

  const tabs = ['All', 'In person', 'Diaspora', 'Academic', 'Conference'];

  const events = [
    {
      id: 1,
      image: '/images/fbc-building.jpg',
      date: '1 August 2026',
      time: 'TBC',
      title: 'FBC Alumni Association UK – African Night',
      location: 'United Kingdom',
      type: 'Diaspora',
      attendees: [
        { initials: 'UK', bg: 'bg-green-400' },
      ],
      attendeeCount: null,
      featured: true,
    },
    {
      id: 2,
      image: '/images/fbc-building.jpg',
      date: 'September 2026',
      time: 'TBC',
      title: 'Alumni Association Dinner',
      location: 'TBC',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 3,
      image: '/images/fbc-building.jpg',
      date: 'October 2026',
      time: 'TBC',
      title: 'Beach Fiesta',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 4,
      image: '/images/fbc-building.jpg',
      date: 'November 2026',
      time: 'TBC',
      title: 'Athletics Competition',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 5,
      image: '/images/fbc-building.jpg',
      date: '31 December 2026',
      time: 'TBC',
      title: 'African Night & Fashion Show',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 6,
      image: '/images/fbc-building.jpg',
      date: 'January 2027',
      time: 'TBC',
      title: 'Football Gala',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 7,
      image: '/images/fbc-building.jpg',
      date: '18 February 2027',
      time: 'TBC',
      title: 'Flag Raising Day',
      location: 'Fourah Bay College, Freetown',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 8,
      image: '/images/fbc-building.jpg',
      date: '30 March 2027',
      time: 'TBC',
      title: 'Meet & Greet',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 9,
      image: '/images/fbc-building.jpg',
      date: '31 March 2027',
      time: 'TBC',
      title: 'Float Parade / Carnival',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 10,
      image: '/images/fbc-building.jpg',
      date: '1 April 2027',
      time: 'TBC',
      title: 'Sports & Cultural Event',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 11,
      image: '/images/fbc-building.jpg',
      date: '2 April 2027',
      time: 'TBC',
      title: 'Alumni Competitions (Sororities & Fraternities)',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 12,
      image: '/images/fbc-building.jpg',
      date: '3 April 2027',
      time: 'Morning & Afternoon',
      title: 'Sponsored Walk (Morning) & Ashobi/Awujo (Afternoon)',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 13,
      image: '/images/fbc-building.jpg',
      date: '4 April 2027',
      time: 'TBC',
      title: 'Thanksgiving Service (Church & Masjid) & March Past',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 14,
      image: '/images/fbc-building.jpg',
      date: '5 April 2027',
      time: 'TBC',
      title: 'Tour to Mabang & Campus Tour',
      location: 'Mabang & Fourah Bay College, Freetown',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 15,
      image: '/images/fbc-building.jpg',
      date: '6 April 2027',
      time: 'TBC',
      title: 'Campus Tours (Old & New Fourah Bay College)',
      location: 'Cline Town & Mount Aureol, Freetown',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 16,
      image: '/images/fbc-building.jpg',
      date: '7 April 2027',
      time: 'TBC',
      title: 'Special Convocation',
      location: 'Fourah Bay College, Freetown',
      type: 'Academic',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 17,
      image: '/images/fbc-building.jpg',
      date: '8–10 April 2027',
      time: 'TBC',
      title: 'International Conference & Inter-Varsity Games',
      location: 'Freetown, Sierra Leone',
      type: 'Conference',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 18,
      image: '/images/fbc-building.jpg',
      date: '10 April 2027',
      time: 'Evening',
      title: 'Dinner & Dance',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
    {
      id: 19,
      image: '/images/fbc-building.jpg',
      date: '11 April 2027',
      time: 'TBC',
      title: 'Beach Fiesta',
      location: 'Freetown, Sierra Leone',
      type: 'In person',
      attendees: [],
      attendeeCount: null,
      featured: false,
    },
  ];

  const filtered = events.filter(e =>
    activeTab === 'All' || e.type === activeTab
  );

  // RSVP handler – reserved for future implementation with backend & auth
  // const toggleRsvp = (id) => { ... };

  return (
    <div className="min-h-screen bg-gray-50 font-sans">

      {/* Premium Hero Header */}
      <div className="bg-white border-b border-gray-100 pt-16 pb-12 mb-10">
        <div className="max-w-4xl mx-auto px-6">
          <div className="inline-flex items-center gap-2 text-fbc-green text-[10px] font-black uppercase tracking-widest mb-4">
            <CalendarDays className="w-3.5 h-3.5" /> FBC CALENDAR
          </div>
          <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-4 tracking-tight">Events & Reunions</h1>
          <p className="text-gray-500 text-lg max-w-2xl leading-relaxed">
            In-person gatherings in Freetown and virtual events for alumni worldwide. Reconnect with the FBC family.
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 pb-20">

        {/* Category Tabs */}
        <div className="flex gap-1 mb-8 border-b border-gray-200 overflow-x-auto">
          {tabs.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-5 py-3 text-sm font-medium transition-all border-b-2 -mb-px whitespace-nowrap ${
                activeTab === tab
                  ? 'border-fbc-green text-fbc-green'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}>
              {tab}
            </button>
          ))}
        </div>

        {/* Events List */}
        <div className="flex flex-col gap-4">
          {filtered.map(event => (
            <div
              key={event.id}
              className="bg-white rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all overflow-hidden flex flex-col sm:flex-row cursor-pointer group">

              {/* Event Image */}
              <div className="relative w-full sm:w-48 h-48 sm:h-auto flex-shrink-0">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover"
                />
                {/* Featured badge */}
                {event.featured && (
                  <div className="absolute top-3 left-3 bg-fbc-gold text-white text-xs font-semibold px-2 py-1">
                    Featured
                  </div>
                )}
                {/* Type badge */}
                <div className={`absolute bottom-3 left-3 text-xs font-semibold px-2 py-1
                  ${event.type === 'Virtual'
                    ? 'bg-blue-600 text-white'
                    : event.type === 'Reunions'
                    ? 'bg-fbc-gold text-white'
                    : 'bg-fbc-green text-white'}`}>
                  {event.type}
                </div>
              </div>

              {/* Event Details */}
              <div className="flex-1 px-6 py-5 flex items-center">
                <div>
                  {/* Date & Time */}
                  <div className="flex items-center gap-4 mb-2">
                    <div className="flex items-center gap-1.5 text-xs text-gray-400">
                      <Calendar className="w-3.5 h-3.5" />
                      <span>{event.date}</span>
                    </div>
                    <div className="flex items-center gap-1.5 text-xs text-gray-400">
                      <Clock className="w-3.5 h-3.5" />
                      <span>{event.time}</span>
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-base font-bold text-gray-900 mb-2 leading-snug">
                    {event.title}
                  </h3>

                  {/* Location */}
                  <div className="flex items-center gap-1.5 text-xs text-gray-500">
                    <MapPin className="w-3.5 h-3.5" />
                    <span>{event.location}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Empty state */}
        {filtered.length === 0 && (
          <div className="text-center py-16">
            <CalendarDays className="w-10 h-10 text-gray-300 mx-auto mb-4" />
            <div className="text-sm font-semibold text-gray-900 mb-1">No events found</div>
            <div className="text-xs text-gray-500">Try selecting a different category</div>
          </div>
        )}

      </div>
    </div>
  );
}

export default Events;